/**
 * Module-level holder for the user's Sentry/Didomi consent decision.
 *
 * `Sentry.init` runs once at bundle load (in `sentry.client.config.ts`), long before Didomi has
 * resolved consent. Sentry's `beforeSend` reads {@link hasSentryConsent} on every event so it can
 * drop events until consent is granted, and the React layer pushes the latest decision in via
 * {@link setSentryConsent} (see `hooks/UseSentry.ts`).
 */
let consentGranted = false;

const setSentryConsent = (granted: boolean): void => {
  consentGranted = granted;
};

const hasSentryConsent = (): boolean => consentGranted;

export { setSentryConsent, hasSentryConsent };
